import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import CalendarViewDropdown from './CalendarViewDropdown';
import { IconButton } from '../ui';

const MobileCalendarToolbar = ({ onPrev, onNext, calendarRef }) => {
  return (
    <div className='relative z-10 flex items-center justify-between '>
      {/* Left: Navigation Buttons */}
      <div className='flex items-center gap-0'>
        <IconButton
          icon={ChevronLeft}
          onClick={onPrev}
          variant='fillPrimary'
          className='border-r-0 rounded-r-none rounded-l-lg px-4'
          tooltip='Previous'
        />
        <IconButton
          icon={ChevronRight}
          onClick={onNext}
          variant='fillPrimary'
          className='border-l-0 rounded-l-none rounded-r-lg px-4'
          tooltip='Next'
        />
      </div>

      {/* Right: View Dropdown */}
      <CalendarViewDropdown calendarRef={calendarRef} />
    </div>
  );
};

export default MobileCalendarToolbar;
